import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  imageAlt?: string;
  keywords?: string;
  type?: string;
  schema?: object;
  canonicalPath?: string;
  noIndex?: boolean;
}

export function SEO({ 
  title = "InfluNex Studio - Premium Influencer Marketing & Creative Agency",
  description = "Influence. Elevated. Premium influencer marketing, Instagram management, product photography, e-commerce services, and creative solutions for modern brands.",
  image = "https://influnex.studio/og-image.jpg",
  imageAlt = "InfluNex Studio - Creative and Influencer Marketing",
  keywords = "influencer marketing, creative agency, Instagram management, product photography, e-commerce",
  type = "website",
  schema,
  canonicalPath = "",
  noIndex = false,
}: SEOProps) {
  const fullTitle = title.includes('InfluNex') ? title : `${title} | InfluNex Studio`;
  const baseUrl = "https://influnex.studio";
  const canonicalUrl = `${baseUrl}${canonicalPath}`;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:site_name" content="InfluNex Studio" />
      <meta property="og:locale" content="en_US" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@InfluNexStudio" />
      <meta name="twitter:creator" content="@InfluNexStudio" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* JSON-LD Schema */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}


